import {
    Box, Button, Paper,
    Table, TableBody, TableCell,
    TableContainer, TableHead, TableRow,
    Typography
} from "@mui/material";

import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchOrders } from '../../store/slice/historySlice'



const AccountTransactions = () => {
    const dispatch = useDispatch()
    const { data } = useSelector(state => state.history)

    useEffect(() => {
        dispatch(fetchOrders())
    }, [dispatch])

    return (
        <>
            <Box>
                <Typography variant="h6">Мои транзакции</Typography>
            </Box>

            <TableContainer component={Paper}>

<Table
    sx={{ tableLayout: 'fixed', minWidth: 300 }}
>
    <colgroup>
        <col style={{ width: '15%' }} />
        <col style={{ width: '15%' }} />
        <col style={{ width: '25%' }} />
        <col style={{ width: '15%' }} />
        <col style={{ width: '15%' }} />
       
    </colgroup>

    <TableHead>
        <TableRow>
            <TableCell>ID</TableCell>
            <TableCell>Сумма</TableCell>
            <TableCell>Адресс</TableCell>
            <TableCell>Дата</TableCell>
            <TableCell>Статус</TableCell>
        </TableRow>
    </TableHead>

    <TableBody>
        {
            data?.user_payout?.map((row) => (
                <TableRow key={row.id}>
                    <TableCell>{row.orderId}</TableCell>
                    <TableCell>{row.amount}</TableCell>
                    <TableCell>{row.payout_address}</TableCell>
                    <TableCell>{row.date}</TableCell>
                    <TableCell>{row.statys}</TableCell>
                </TableRow>
            ))
        }
    </TableBody>

</Table>

</TableContainer>
        </>
    )
}

export default AccountTransactions;